// location.search param names
export const SIGNUP_REDIRECT = 'signupRedirect';
export const LOGIN_REDIRECT = 'loginRedirect';
